
<div>
    <button (click)="closeDialogue()" class="closeButton m-hide">X</button>
    <div class="schadule-table">
    <table class="table table-bordered table-striped table-responsive-stack" *ngIf="examName == 'NEET';">
        <thead>
            <tr>
                <th>Test No.</th>
                <th>Date</th> 
                <th>Day</th>    
                <th>Time</th>
                <th>Syllabus</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>ILTS 1</td>

                <td>27th June</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Class XI First Half Syllabus</td>
            </tr>
            <tr>
                <td>ILTS 2</td>

                <td>3rd July</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Class XI Second Half Syllabus</td>
            </tr>
            <tr>
                
                <td>ILTS 3</td>

                <td>4th July</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Class XI Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 4</td>

                <td>6th July</td>

                <td>Tue</td>

                <td>2 pm to 5 pm</td>

                <td>Class XII First Half Syllabus</td>
            </tr>

            <tr>
                
                <td>ILTS 5</td>

                <td>8th July</td>

                <td>Thu</td>

                <td>2 pm to 5 pm</td>

                <td>Class XII Second Half Syllabus</td>
            </tr>

            <tr>
                
                <td>ILTS 6</td>

                <td>10th July</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Class XII Full Syllabus</td>
            </tr>
    
            <tr>
                <td>ILTS 7</td>

                <td>11th July</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            <tr>
                <td>ILTS 8</td>

                <td>14th July</td>

                <td>Wed</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
    
            </tr>
    
            <tr>
                <td>ILTS 1 (New Pattern)</td>

                <td>17th July</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            <tr>
                <td>ILTS 2 (New Pattern)</td>

                <td>18th July</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>

            </tr>
            
            <tr>
                <td>ILTS 3 (New Pattern)</td>

                <td>24th July</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 4 (New Pattern)</td>

                <td>25th July</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            <tr>
                <td>ILTS 5 (New Pattern)</td>

                <td>31st July</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 6 (New Pattern)</td>

                <td>1st Aug</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            
            <tr>
                <td>ILTS 7 (New Pattern)</td>

                <td>7th Aug</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            <tr>
                <td>ILTS 8 (New Pattern)</td>

                <td>8th Aug</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
    
            <tr>
                <td>ILTS 9 (New Pattern)</td>

                <td>14th Aug</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            <tr>
                <td>ILTS 10 (New Pattern)</td>

                <td>21st Aug</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 11 (New Pattern)</td>

                <td>22nd Aug</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 12 (New Pattern)</td>

                <td>28th Aug</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 13 (New Pattern)</td>

                <td>29th Aug</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            
            <tr>
                <td>ILTS 14 (New Pattern)</td>

                <td>31st Aug</td>

                <td>Tue</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            

            <tr>
                <td>ILTS 15 (New Pattern)</td>

                <td>2nd Sep</td>

                <td>Thu</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            

            <tr>
                <td>ILTS 16 (New Pattern)</td>

                <td>4th Sep</td>

                <td>Sat</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 17 (New Pattern)</td>

                <td>5th Sep</td>

                <td>Sun</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>

            <tr>
                <td>ILTS 18 (New Pattern)</td>

                <td>6th Sep</td>

                <td>Mon</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            

            <tr>
                <td>ILTS 19 (New Pattern)</td>

                <td>8th Sep</td>

                <td>Wed</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>
            

            <tr>
                <td>ILTS 20 (New Pattern)</td>

                <td>10th Sep</td>

                <td>Fri</td>

                <td>2 pm to 5 pm</td>

                <td>Full Syllabus</td>
            </tr>    
        </tbody>
    </table>
    <table class="table table-bordered table-striped table-responsive-stack" *ngIf="examName == 'JEEMAIN' || examName == 'JEE'">
        <thead>
            <tr>
                <th>Test No.</th>
                <th>Date</th> 
                <th>Day</th>    
                <th>Time</th>
                <th>Syllabus</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let s of Jeeschedule; index as i">
                <td>ILTS {{i+1}}</td>

                <td>{{s.dt}}</td>

                <td>{{s.day}}</td>

                <td>2 pm to 5 pm</td>

                <td>Full SYLLABUS</td>
            </tr>
        </tbody>
    </table>
    </div>
</div>